import useBrazilianIssuer from "components/company/v3/context/hooks/useBrazilianIssuer";
import { HistoryIcon } from "lucide-react";
import { FormattedMessage } from "react-intl";

export default function BrazilianBriefHistoryContent() {
  const issuer = useBrazilianIssuer();
  const { briefHistory } = issuer;

  if (!briefHistory) {
    return null;
  }

  return (
    <div className="h-full min-h-0 w-full space-y-8 overflow-y-auto pr-1 font-aeonik">
      <section className="space-y-1">
        <h2 className="flex items-center gap-2 text-xl font-bold tracking-tight text-slate-800 dark:text-slate-200">
          <HistoryIcon
            aria-hidden={true}
            className="size-5 shrink-0 text-indigo-500 dark:text-indigo-300"
            strokeWidth={2}
          />
          <FormattedMessage defaultMessage="Histórico" id="ZyJcEI" />
        </h2>
        <p className="text-sm leading-7 text-slate-600 dark:text-slate-300">{briefHistory.summary}</p>
      </section>

      {briefHistory.timeline.length > 0 && (
        <ol className="ml-2 space-y-6 border-l border-slate-200 dark:border-slate-700">
          {briefHistory.timeline.map((entry, index) => {
            return (
              <li key={`${entry.year}-${index}`} className="relative pl-7">
                <span
                  aria-hidden={true}
                  className="absolute -left-1.5 top-1.5 size-3 rounded-full border-2 border-white bg-indigo-500 dark:border-slate-900 dark:bg-indigo-400"
                />

                <time className="font-mono text-sm font-bold text-indigo-600 dark:text-indigo-300">{entry.year}</time>
                <p className="mt-1 text-sm leading-6 text-slate-600 dark:text-slate-300">{entry.text}</p>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
